import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import Home  from './pages/Homepage';
import Header from "./common/Header"
import Footer from './common/Footer';
import BookingPage from './BookingForm/Bookingform';
import AttachYourCab from './pages/AttachYourCab';
import ContactPage from './pages/ContactPage';
import AboutUs from './pages/AboutUs';
import AuthPage from './common/Signin';
import AirportTransfer from './pages/service/AirportTransfer';
import LocalPackages from './pages/service/LocalPackages';
import OutstationTrips from './pages/service/OutstationTrips';
import BookingConfirmation from './BookingForm/BookingConfirmation';
import ScrollToTop from './common/ScrollToTop';
// import About from './components/About';
// import Contact from './components/Contact';

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/attachyourcab" element={<AttachYourCab />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutUs />} />

        <Route path="/services/airport-transfer" element={<AirportTransfer />} />
        <Route path="/services/local" element={<LocalPackages />} />
        <Route path="/services/outstation-trips" element={<OutstationTrips />} />
        <Route path="/booking-confirmation" element={<BookingConfirmation />} />

        <Route path="/signin" element={<AuthPage />} />
        <Route path="/signup" element={<AuthPage />} />
        {/* <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} /> */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
